import { takeLatest, put, call } from 'redux-saga/effects';
import {
    fetchQuestionsStart,
    fetchQuestionsSuccess,
    fetchQuestionsFail,
    submitAnswerStart,
    submitAnswerSuccess,
    submitAnswerFail,
    finalizeUserResultStart,
    finalizeUserResultSuccess,
    finalizeUserResultFail,
    fetchUserResultStart,
    fetchUserResultSuccess,
    fetchUserResultFail,
    createNewAssessmentRequestStart,
    createNewAssessmentRequestFail,
    createNewAssessmentRequestSuccess
} from '../slices/assessmentSlice';
import { getRequest, postRequest } from '../../network';
import { ASSESSMENT_QUESTIONS, FINALIZE_USER_RESULT, REQUEST_NEW_ASSESSMENT, SUBMIT_ANSWER, USER_RESULT } from '../apis';

function* fetchQuestionsSaga(action) {
    try {
        const response = yield call(getRequest, ASSESSMENT_QUESTIONS);
        yield put(fetchQuestionsSuccess(response));
    } catch (error) {
        yield put(fetchQuestionsFail(error.message));
    }
}

function* submitAnswerSaga(action) {
    try {
        const response = yield call(postRequest, SUBMIT_ANSWER, action.payload.params);
        yield put(submitAnswerSuccess(response));
        action.payload.callback(null, response);
    } catch (error) {
        yield put(submitAnswerFail(error.message));
        action.payload.callback(error.message, null);
    }
}
function* finalizeUserResultSaga(action) {
    try {
        const response = yield call(postRequest, FINALIZE_USER_RESULT, action.payload.params);
        yield put(finalizeUserResultSuccess(response));
        action.payload.callback(null, response);
    } catch (error) {
        yield put(finalizeUserResultFail(error.message));
        action.payload.callback(error.message, null);
    }
}

function* fetchUserResultSaga(action) {
    try {
        const response = yield call(getRequest, USER_RESULT);
        yield put(fetchUserResultSuccess(response));
    } catch (error) {
        yield put(fetchUserResultFail(error.message));
    }
}

function* createNewAssessmentRequest(action) {
    try {
        const response = yield call(postRequest, REQUEST_NEW_ASSESSMENT, action.payload.params);
        yield put(createNewAssessmentRequestSuccess(response));
        action.payload.callback(null, response);
    } catch (error) {
        const message = error.response.data.message || error.message || "Failed to create reassessment request.";
        yield put(createNewAssessmentRequestFail(message));
        action.payload.callback(message, null);
    }
}

export function* watchAssessment() {
    yield takeLatest(fetchQuestionsStart.type, fetchQuestionsSaga);
    yield takeLatest(submitAnswerStart.type, submitAnswerSaga);
    yield takeLatest(finalizeUserResultStart.type, finalizeUserResultSaga);
    yield takeLatest(fetchUserResultStart.type, fetchUserResultSaga);
    yield takeLatest(createNewAssessmentRequestStart.type, createNewAssessmentRequest);
}